import { createAction } from "@reduxjs/toolkit";

export const priceList = createAction<any>("prices/lists");

export const priceList_gns = createAction<any>("prices_gns/lists");

export const edetRewards = createAction<any>("edetRewards/lists");
